import * as yup from 'yup';
import localization from "@/app/lib/Yup/localization";

yup.setLocale(localization)

export default yup;
